module.exports = __webpack_public_path__ + "img/berita-terbaru-w.e182bef8.svg";